import React, { FC, createContext, useContext, useMemo } from 'react';
import { useRobloxAuthentication } from '@rbx/auth';

export const IsAuthenticatedContext = createContext<{
  login: () => Promise<void>;
  isAuthLoaded: boolean;
  isAuthenticated: boolean;
} | null>(null);

export const IsAuthenticatedProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const { user: authenticatedUser, isFetched: isAuthLoaded, login } = useRobloxAuthentication();
  const isAuthenticated = useMemo(
    () => isAuthLoaded && !!authenticatedUser?.id,
    [isAuthLoaded, authenticatedUser],
  );
  const isAuthenticatedState = useMemo(() => {
    return { login, isAuthLoaded, isAuthenticated };
  }, [login, isAuthLoaded, isAuthenticated]);
  return (
    <IsAuthenticatedContext.Provider value={isAuthenticatedState}>
      {children}
    </IsAuthenticatedContext.Provider>
  );
};

export const useIsAuthenticated = () => {
  const context = useContext(IsAuthenticatedContext);
  if (!context) {
    throw new Error('useIsAuthenticated must be used within a IsAuthenticatedProvider');
  }
  return context;
};
